import { reaction } from "mobx";
import { flow, getEnv, Instance, types } from "mobx-state-tree";
import { endpoints } from "../api/ApiEndpoints";
import { api } from "../api/ApiService";
import { StorageModel } from "../storage/StorageModel";
import { ActivityTypes } from "./ActivityPricesStorage";
import { authentication } from "../authentication/Authentication";
import { currentUserService } from "../user/CurrentUserStorage";
import { translationService } from "../translation/TranslationService";

const CreditBalanceModel = types.model({
    balance: types.optional(types.frozen<number>(), -1)
})

export const CreditBalanceStorageModel = types
    .compose(CreditBalanceModel, StorageModel)
    .named("CreditBalanceStorageModel")
    .actions((self) => {
        return {
            mapResponse(response: {item1:number,item2:number}) {
                self.balance = response.item1 - response.item2;
            },
            getCustomerPortalSessionLink: flow(function* () {
                const endpoint = endpoints.get("shop_orders");
                endpoint.queryParams = "language=" + translationService.language;
                return yield getEnv(self).api.get(endpoint);
            }),
            validateRemainingBalance: flow(function* (activities: ActivityTypes[]) {
                const endpoint = endpoints.get("validate_user_balance");
                endpoint.queryParams = "services=" + activities.join("&services=");
                try {
                    yield getEnv(self).api.get(endpoint);
                    return true;
                } catch (error) {
                    return false;
                }
            }),
            mockup() {
                self.balance = 0;
            }
        }
    })
    .views((self) => ({
        get endpoint() {
            return endpoints.get("current_user_balance");
        },
        get isLoading() {
            return self.balance < 0;
        },
        get canLoadItems() {
            return getEnv(self).currentUserService.currentUser.id>-1;
        },
    }))

export const creditBalanceStorage = CreditBalanceStorageModel.create({}, { api, currentUserService });
export type CreditBalanceStorage = Instance<typeof CreditBalanceStorageModel>;

reaction(
    () => currentUserService.currentUser.id,
    async () => {
      if (authentication.anonymous) {
        creditBalanceStorage.mockup();
      } else {
        await creditBalanceStorage.load();
      }
    }
  );
  
reaction(
    () => authentication.anonymous,
    async () => {
      if (!authentication.anonymous) await creditBalanceStorage.load();
    }
  )